import _ from "lodash";

export const testResultStatuses = {
  pending: "",
  pass: 1,
  noTesting: 2
};

export const isResultPass = status => status === testResultStatuses.pass;
export const isResultNoTesting = status =>
  status === testResultStatuses.noTesting;

export function getTestResultTitle(status) {
  switch (status) {
    case testStatuses.pending:
      return "Pending";
    case testStatuses.accepted:
      return "Accepted";
    case testStatuses.rejected:
      return "Rejected";
    case testStatuses.complete:
      return "Complete";
    case testStatuses.underReview:
      return "Under Review";
    default:
      return "All";
  }
}

export function getTestPassedTitle(status) {
  switch (status) {
    case testResultStatuses.pass:
      return "Pass";
    case testResultStatuses.noTesting:
      return "No Testing";
    default:
      return "Wrong Status ID";
  }
}

export const testTypes = {
  winnfTs0122: {
    title: "WINNF-TS-0122",
    id: 62
  }
};

export const findTestById = id => {
  return _.find(testTypes, ["id", id]);
};

export const findTestCodeById = id => {
  return _.findKey(testTypes, ["id", id]);
};

export const testStatuses = {
  all: 0,
  pending: 1,
  accepted: 2,
  rejected: 3,
  underReview: 4,
  complete: 5
};

export const testStringStatuses = {
  all: "All",
  pending: "Pending",
  accepted: "Accepted",
  rejected: "Rejected",
  underReview: "Under Review",
  complete: "Complete"
};

export const findStringStatusId = stringStatus => {
  const statusKey = _.findKey(
    testStringStatuses,
    status => status === stringStatus
  );

  if (!statusKey) return testStatuses.pending;

  return testStatuses[statusKey];
};

export const isAccepted = status => status === testStatuses.accepted;
export const isAcceptedString = status =>
  status === testStringStatuses.accepted;
export const isRejected = status => status === testStatuses.rejected;
export const isRejectedString = status =>
  status === testStringStatuses.rejected;
export const isPending = status => status === testStatuses.pending;
export const isPendingString = status => status === testStringStatuses.pending;
export const isComplete = status => status === testStatuses.complete;
export const isCompleteString = status =>
  status === testStringStatuses.complete;
export const isUnderReview = status => status === testStatuses.underReview;
export const isUnderReviewString = status =>
  status === testStringStatuses.underReview;

export const canBeAcceptedForTesting = status => {
  return isPending(status) || isAccepted(status) || isRejected(status);
};

export const getTestStatusGroup = (status = testStatuses.pending) => {
  const {
    pending,
    accepted,
    rejected,
    underReview,
    complete
  } = testStringStatuses;
  switch (status) {
    case pending:
      return [pending];
    case accepted:
      return [accepted];
    case rejected:
      return [rejected];
    case underReview:
      return [underReview];
    case complete:
      return [complete];
    default:
      return [pending, accepted, rejected, underReview, complete];
  }
};

// ==== Old-fashioned style with digit ids ====
// export const getTestStatusGroup = (status = testStatuses.pending) => {
//   const { pending, accepted, rejected, underReview, complete } = testStatuses;
//   switch (status) {
//     case pending:
//       return [pending];
//     case accepted:
//       return [accepted];
//     case rejected:
//       return [rejected];
//     case underReview:
//       return [underReview];
//     case complete:
//       return [complete];
//     default:
//       return [pending, accepted, rejected, underReview, complete];
//   }
// };

export function hasPreparedResults(results) {
  if (!results.length) return false;

  return results.some(element => element.file && element.title);
}

export const getConductLabsArgs = labList => {
  if (!labList || !labList.length) return [];

  return _.map(labList, lab => {
    return {
      labid: _.every(labList, _.isObject) ? lab.labid : lab
    };
  });
};

export function hasReportDocuments(reports) {
  if (!reports.length) return false;

  return reports.some(report => _.isObject(report.document));
}

export function hasReportsApproved(tests, testId) {
  if (!tests.length) return false;

  const testModule = _.find(tests, ["id", testId]);

  if (!testModule) return false;
  if (isComplete(testModule.requestteststatusid)) return true;

  return (
    testModule.reports.length > 0 && testModule.reports.every(isReportApproved)
  );
}

export function isReportApproved(report) {
  return report.approved === 1;
}

export function countReports(reports) {
  if (!reports.length) return 0;

  const wef = _.filter(reports, "document");
  return wef.length;
}

export const getReports = list => {
  if (!list.length) return null;

  return _.filter(list, "document");
};

export const hasTestResults = testStatusId => {
  const statusList = [testStatuses.underReview, testStatuses.complete];

  return _.indexOf(statusList, testStatusId) > -1;
};



// WEBPACK FOOTER //
// ./src/helpers/RequestTestsHelper.js